export const useResolution = () => ({
  isSmallDesktop: window.innerWidth < 1024
})
